import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductLevelIcon',
  props: {
  icon: String
},
  setup(__props) {



return { __sfc: true, }
}

})